import { forwardRef } from "react";
import { SystemFieldType, SystemPageType } from "../../../../Model/SystemModels";
import { CardField } from "../../../Common/Template/Card/CardField";
import { CardGroup } from "../../../Common/Template/Card/CardGroup";
import PageContainer, { PageContainerBase } from "../../../Common/Template/PageContainer";
import { t } from "i18next";

export const AdminAtecoLevel2Card = forwardRef<PageContainerBase, React.PropsWithChildren<{}>>((props, ref) => {
    return (
        <PageContainer pageType={SystemPageType.Card} title={t("adminCenter:atecoLevel2Card:title")} endpoint="odata/ateco/level/2" ref={ref}>
            <CardGroup name="general" label={t("adminCenter:atecoLevel2Card:groups:general")} isOpen={true}>
                <CardField name="code" type={SystemFieldType.String} label={t("adminCenter:atecoLevel2Card:fields:code")} />
                <CardField name="description" type={SystemFieldType.String} label={t("adminCenter:atecoLevel2Card:fields:description")} />
                <CardField name="level1Code" type={SystemFieldType.String} label={t("adminCenter:atecoLevel2Card:fields:level1Code")} hasTableRelation tableRelationEndpoint="odata/ateco/level/1" tableRelationKey="code" tableRelationField="code" />
                <CardField name="industryCode" type={SystemFieldType.String} label={t("adminCenter:atecoLevel2Card:fields:industryCode")} hasTableRelation tableRelationEndpoint="odata/industry" tableRelationKey="code" tableRelationField="code" />
            </CardGroup>
        </PageContainer>
    );
});